import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVar } from '../globals/global-var';
import { Observable } from 'rxjs';
import { TeacherProfile } from '../models/teacher-profile';
import { Invite } from '../models/invite';
import { ClassCourseSch } from '../models/class-course-sch';

@Injectable({
  providedIn: 'root'
})
export class TeacherService {
  constructor(private http: HttpClient, private globalVar: GlobalVar) { }

  getTeacherProfileListApi(keyword: string): Observable<TeacherProfile[]> {
    return this.http.get<TeacherProfile[]>(this.globalVar.targetIp + '/api/Teacher/Profile', { params: { keyword: keyword } });
  }

  postTeacherProfileApi(teacherProfile: TeacherProfile): Observable<any> {
    return this.http.post<any>(this.globalVar.targetIp + '/api/Teacher/Profile', teacherProfile);
  }

  getTeacherProfileApi(id: string): Observable<TeacherProfile> {
    return this.http.get<TeacherProfile>(this.globalVar.targetIp + '/api/Teacher/Profile/' + id);
  }

  putTeacherProfileApi(id: string, teacherProfile: TeacherProfile): Observable<any> {
    return this.http.put<any>(this.globalVar.targetIp + '/api/Teacher/Profile/' + id, teacherProfile);
  }

  deleteTeacherProfileApi(id: string): Observable<any> {
    return this.http.delete<any>(this.globalVar.targetIp + '/api/Teacher/Profile/' + id);
  }


  //TeacherSch
  getTeacherScheduleListApi(teacherId: string): Observable<ClassCourseSch[]> {
    return this.http.get<ClassCourseSch[]>(this.globalVar.targetIp + '/api/Teacher/profile/Schedule/' + teacherId);
  }



  getInviteListApi(keyword: string): Observable<Invite[]> {
    return this.http.get<Invite[]>(this.globalVar.targetIp + '/api/Teacher/Invite', { params: { keyword: keyword } });
  }

  getInviteApi(id: string): Observable<Invite> {
    return this.http.get<Invite>(this.globalVar.targetIp + '/api/Teacher/Invite/' + id);
  }

  deleteInviteApi(id: string): Observable<any> {
    return this.http.delete<any>(this.globalVar.targetIp + '/api/Teacher/Invite/' + id);
  }


}
